import { logger } from "../../analytics/logger";
export var analyticsClientStub = {
    logger: logger
};
